import React from "react";
import "./Button.scss"
import arrow from "../../assets/btn-arr.svg"
const Button = ({ text, isloading, onClick, width, isSecondary = false, isBorder = false, isArrow = false, height }) => {
    return (
        <div className={`HoppersCafe-Button ${isSecondary ? "HoppersCafe-SecButton" : isBorder ? "VirasatV2Default-borderButton" : ""}`} onClick={onClick} style={{ width, height }}>
            {isloading && <div className="loader-btn" />}
            {text}
            {isArrow && <img alt="" src={arrow} className="btn-arrw-img" />}
        </div>
    )
}
export default Button